module.exports = __webpack_public_path__ + "img/banner-differents.9dada409.jpg";